// Item view for a factoryfixture_devicegroup intended to be used by the
// show_factory_devicegroups controller


import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DeviceGroupItemMixin from '@/views/list_item/device_group_item';

var globalCh = Radio.channel('global');

var FactoryDevicegroupItemView = Marionette.View.extend(DeviceGroupItemMixin).extend({
    initialize: function() {
        this.render_device_group_info = DeviceGroupItemMixin.render_device_group_info;
        this.listenTo(this.model.rel, 'change:current_deployment', this.check_go_live);
        this.listenTo(this.model.rel, 'change:production_target', this.check_go_live);
        this.listenTo(this.model.rel, 'change:dut_target', this.check_go_live);
    },
    templateContext: function (data) {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        let icon = 'ei-icon-' + this.model.type;
        let show_draft = false;
        let show_code_history = false;
        let show_edit = active.permits(primary, 'update_pre_factory_devicegroup');
        let show_test_zone = false;
        let show_settings = false;
        let show_delete = false;
        let show_devices = false;
        let show_deploy = false;
        let show_go_live = false;

        if (this.model.type === 'pre_factoryfixture_devicegroup') {
            show_draft = active.permits(primary, 'update_pre_factory_deployment');
            show_code_history = active.permits(primary, 'view_pre_factory_deployments');
            show_edit = active.permits(primary, 'update_pre_factory_devicegroup');
            show_test_zone = active.permits(primary, 'view_pre_factory_devicegroups');
            show_settings = active.permits(primary, 'update_pre_factory_devicegroup');
            show_delete = active.permits(primary, 'delete_pre_factory_devicegroup');
            show_devices = active.permits(primary, 'view_pre_factory_devices');
            show_deploy = active.permits(primary, 'update_pre_factory_devicegroup');
            show_go_live = active.permits(primary, 'create_production_devicegroup');
        } else if (this.model.type === 'factoryfixture_devicegroup') {
            show_draft = false;
            show_code_history = active.permits(primary, 'view_factory_deployments');
            show_edit = active.permits(primary, 'update_factory_devicegroup');
            show_test_zone = active.permits(primary, 'view_pre_factory_devicegroups');
            show_settings = active.permits(primary, 'update_factory_devicegroup');
            show_delete = active.permits(primary, 'delete_factory_devicegroup');
            show_devices = active.permits(primary, 'view_factory_devices');
            show_deploy = active.permits(primary, 'update_factory_devicegroup');
            show_go_live = false;
        }

        return {
            icon: icon,
            type: this.model.type,
            show_actions: true,
            show_draft: show_draft,
            show_code_history: show_code_history,
            show_edit: show_edit,
            show_delete: show_delete,
            show_devices: show_devices,
            show_settings: show_settings,
            show_go_live: show_go_live,
            show_test_zone: show_test_zone,
            show_deploy: show_deploy,
            expandable: this.getOption('expandable'),
            relationship_type: this.getOption('relationship_type')
        };
    },
    className: function(){
        if ( this.getOption('expandable') ) { 
            return 'section';
        }
        return 'section full';
    },
    attributes: function() {
        return {
            "data-id" : this.model.id,
        };
    },
    expand: function(e) {
        e.stopPropagation();
        this.ui.retracto.show();
        this.ui.expando.hide();
        this.render_relationships(['dut_target', 'production_target']);
    },
    render_go_live: function(bool) {
        if ( !this.templateContext().show_go_live ) return;
        let true_template = 'Go Live';
        let false_template = '<button data-toggle="tooltip" data-placement="bottom"'+
                             'title="Go Live requires targets for the Test Factory and Fixture Device Groups. '+
                             'Follow the Code button to create and edit Test Factory code and make deployments. '+
                             'Go to the Test Production Device Group, and then edit Code to create a Test Production Deployment."'+
                             'class="btn btn-link action disabled">Go Live</button>';

        let go_live_view = Marionette.View.extend({
            template: Handlebars.compile(true_template),
            tagName: 'button',
            className: 'btn btn-link actions go-live',
            triggers: {
                'click' : 'trigger:show_go_live'
            }
        });
        if ( !bool ) {
            go_live_view = go_live_view.extend({
                template: Handlebars.compile(false_template),
                tagName: 'span',
                className: undefined,
                ui: {
                    tooltips: '[data-toggle="tooltip"]'
                },
                triggers: {},
                events: {
                    'mouseout' : 'cleanup_tooltip',
                },
                onRender: function(){
                    this.ui.tooltips.tooltip();
                },
                cleanup_tooltip : function() {
                    this.ui.tooltips.tooltip('hide');
                }
            });
        }
        this.showChildView('go_live_region', new go_live_view());
    },
    ui: {
        name: '.name',
        draft_code: '.action.draft-code',
        code_history: '.action.code-history',
        delete: '.action.delete',
        settings: '.action.settings',
        devices: '.action.devices,  .devices-link',
        blessed_devices: '.action.blessed-devices',
        go_live: '.action.go-live',
        go_live_region: '.go-live-region',
        tooltips: '[data-toggle="tooltip"]',
        deploy: '.action.deploy',
        expando: 'nav > .expando',
        retracto: 'nav > .retracto'
    },
    regions: {
        devicegroup_info: '.devicegroup-info',
        devicecount_info: '.devicecount-info',
        deployment_info: '.deployment-info',
        last_deployed_info: '.last-deployed-info',
        relationships_region: '.relationships-region',
        go_live_region: '.go-live-region'
    },
    childViewEvents: {
        'trigger:show_go_live': 'show_go_live'
    },
    events: {
        'click @ui.name' : 'show_dashboard',
        'click @ui.draft_code': 'show_draft_code',
        'click @ui.code_history': 'show_code_history',
        'click @ui.delete': 'show_delete_dialog',
        'click @ui.devices': 'show_devices',
        'click @ui.settings': 'show_settings_dialog',
        'click @ui.blessed_devices': 'show_blessed_devices',
        'click @ui.go_live': 'show_go_live',
        'click @ui.deploy': 'show_deployment_dialog',
        'click @ui.expando': 'expand',
        'click @ui.retracto': 'retract',
    },
    modelEvents: {
        'change': 'render'
    },
    show_dashboard: function(e) {
        e.stopPropagation();
        if (e.which === 1) {
            globalCh.request('show_devicegroup_dashboard', this.model, this.model.rel.get('product'));
            return false;
        }
    },
    check_go_live: function() {
        let show_go_live = this.templateContext().show_go_live;
        let production_target = this.model.rel.get('production_target');
        let dut_target = this.model.rel.get('dut_target');
        if ( !production_target || !dut_target ) {
            this.render_go_live(false);
            return false;
        }
        let production_target_deployment = production_target.rel.get('current_deployment');
        let current_deployment = this.model.rel.get('current_deployment');
        let dut_deployment = dut_target.rel.get('current_deployment');

        let pt_flagged = production_target_deployment && production_target_deployment.get('flagged');
        let cd_flagged = current_deployment && current_deployment.get('flagged');
        let dut_flagged = dut_deployment && dut_deployment.get('flagged');

        if ( production_target_deployment && pt_flagged === undefined ) {
            production_target_deployment.fetch().then(
                function(resp){
                    this.model.rel.trigger('change:production_target');
                }.bind(this));
        }
        if ( dut_deployment && dut_flagged === undefined ) {
            dut_deployment.fetch().then(
                function(resp){
                    this.model.rel.trigger('change:dut_target');
                }.bind(this));
        }
        if ( current_deployment && cd_flagged === undefined ) {
            current_deployment.fetch().then(
                function(resp){
                    this.model.rel.trigger('change:current_deployment');
                }.bind(this));
        }
        if ( show_go_live
            && production_target_deployment && pt_flagged === true
            && current_deployment && current_deployment.get('flagged') === true
            && dut_deployment && dut_flagged === true ) {
                this.render_go_live(true);
                return true;
        } else {
            this.render_go_live(false);
            return false;
        }
    },
    onRender: function(){
        this.ui.retracto.hide();
        this.render_device_group_info();
        this.model.rel.load_all().then(
            function() {
                this.check_go_live();
            }.bind(this)
        );
        this.listenTo(this.model.rel, 'change:current_deployment', function(){ this.render_device_group_info(); });
        this.listenTo(this.model.rel, 'change:dut_target', function(){ this.render_device_group_info(); });
        this.listenTo(this.model.rel, 'change:production_target', function(){ this.render_device_group_info(); });
        this.listenTo(this.model, 'change', this.render);
    },
    // Overridden actions, or other actions custom to this devicegroup type
    show_draft_code: function() {
        var draft = this.model.draft;
        var devicegroup = this.model;
        
        globalCh.request('showCodeEditor', draft, devicegroup);
    },
    show_code_history: function() {
        globalCh.request('show_devicegroup_code_history',
                                    this.model,
                                    this.model.rel.get('product'));
    },
    show_settings_dialog: function() {
        globalCh.request('show_factory_device_group_settings_dialog', this.model, this.model.type);
    },
    show_blessed_devices: function() {
        globalCh.request('show_pre_factoryfixture_devices', this.model);
    },
    show_go_live: function() {
        var options = {
            pre_factoryfixture_devicegroup: this.model
        };
        globalCh.request('show_go_live', options);
    },
    show_deployment_dialog: function () {
        globalCh.request('show_create_deployment_dialog', this.model);
    },
});

export default FactoryDevicegroupItemView;

